// @flow

import { SelectProps } from 'antd/lib/select';
import React from 'react';

import { companyApi } from '../../lib/api';
import type { Company } from '../../lib/types';
import AutocompleteSelect from './AutocompleteSelect';

export default (selectProps: SelectProps) => (
  <AutocompleteSelect
    placeholder="Выберите компанию"
    fetch={async params => {
      return await companyApi.fetch({
        isArchived: false,
        isDeleted: false,
        ...params
      });
    }}
    fetchSingle={companyApi.get}
    notFoundText="Юридические лица не найдены"
    renderOption={(company: Company, Option) => (
      <Option key={company.id} value={company.id} company={company}>
        {company.name}
      </Option>
    )}
    {...selectProps}
  />
);
